export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6760.7d14c63c.jpg";